module.exports = __webpack_public_path__ + "img/12.f7c46453.png";